import { CodebookModel } from 'app/shared/model/shared.model';
import { DkpCadastralParcelModel } from 'app/edozvola/cases/case-location/model/case-location.model';

export interface CaseBuildingPlotModel {
  plotBeingFormed: boolean;
  formationCommitment: CodebookModel[];
  plotRatio: number;
  geometryExists: boolean;
}

export interface PlotBeingCreatedModel {
  idPlotBeingCreated?: number;
  cadastralMunicipality: CodebookModel[];
  plot: string;
  beingCreatedFrom: DkpCadastralParcelModel[];
}

export interface PlotBeingCreatedViewModel {
  idPlotBeingCreated: number;
  cadastralMunicipality: string;
  plot: string;
  beingCreatedFrom: string;
}

export const plotBeingCreatedInitial = {
  cadastralMunicipality: [],
  plot: '',
  beingCreatedFrom: []
}
